'use client';

import React from 'react';

export default function AboutSection() {
  return (
    <section id="about" className="py-12 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* About Us card */}
          <div
            className="rounded-xl p-8 relative overflow-hidden"
            style={{
              background: 'linear-gradient(135deg, #fff7ed 0%, #ffedd5 100%)',
              border: '1px solid #fed7aa',
              minHeight: '200px',
            }}
          >
            <div className="relative z-10">
              <div className="text-4xl mb-4">🏢</div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">About KARFIN</h3>
              <p className="text-sm text-gray-600 mb-4">How we are building a strong KARFIN brand for India&apos;s financial future</p>
              <a
                href="#"
                className="inline-flex items-center gap-2 bg-primary text-white font-semibold text-sm px-4 py-2 rounded-lg hover:bg-primary-dark transition-colors"
              >
                Know More &rarr;
              </a>
            </div>
            <div className="absolute -bottom-8 -right-8 w-32 h-32 rounded-full bg-orange-200 opacity-40"></div>
            <div className="absolute -bottom-4 -right-4 w-20 h-20 rounded-full bg-orange-300 opacity-30"></div>
          </div>

          {/* Work with us card */}
          <div
            className="rounded-xl p-8 relative overflow-hidden"
            style={{
              background: 'linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)',
              border: '1px solid #bbf7d0',
              minHeight: '200px',
            }}
          >
            <div className="relative z-10">
              <div className="text-4xl mb-4">💼</div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Work with KARFIN</h3>
              <p className="text-sm text-gray-600 mb-4">Want to Join Team KARFIN? Build your career in India&apos;s fastest growing fintech</p>
              <a
                href="#"
                className="inline-flex items-center gap-2 bg-primary text-white font-semibold text-sm px-4 py-2 rounded-lg hover:bg-primary-dark transition-colors"
              >
                Join Us &rarr;
              </a>
            </div>
            <div className="absolute -bottom-8 -right-8 w-32 h-32 rounded-full bg-green-200 opacity-40"></div>
            <div className="absolute -bottom-4 -right-4 w-20 h-20 rounded-full bg-green-300 opacity-30"></div>
          </div>
        </div>

        {/* Founder Profile */}
        <div className="mt-10">
          <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center">Meet Our Founder</h2>
          <div className="flex justify-center">
            <div className="bg-white rounded-2xl shadow-md border border-gray-200 p-8 flex flex-col sm:flex-row items-center gap-8 max-w-2xl w-full">
              {/* Founder Photo */}
              <div className="flex-shrink-0">
                <div className="relative">
                  <img
                    src="/assets/images/WhatsApp_Image_2026-04-05_at_23.13.03-1775411009305.jpeg"
                    alt="Sabasis Nayak - Founder & CEO of KARFIN, 15 years banking expertise"
                    className="w-28 h-28 rounded-full object-cover border-4 border-primary shadow-md"
                    onError={(e) => {
                      const target = e.currentTarget as HTMLImageElement;
                      target.style.display = 'none';
                      const fallback = target.nextElementSibling as HTMLElement;
                      if (fallback) fallback.style.display = 'flex';
                    }}
                  />
                  <div
                    className="w-28 h-28 rounded-full items-center justify-center text-white text-4xl font-bold shadow-md border-4 border-primary"
                    style={{ background: 'linear-gradient(135deg, #E07B1A 0%, #f5a623 100%)', display: 'none' }}
                  >
                    SN
                  </div>
                  {/* Orange ring accent */}
                  <div className="absolute -bottom-1 -right-1 w-8 h-8 rounded-full bg-primary flex items-center justify-center">
                    <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                    </svg>
                  </div>
                </div>
              </div>
              {/* Info */}
              <div className="text-center sm:text-left">
                <h3 className="text-xl font-bold text-gray-900">Sabasis Nayak</h3>
                <p className="font-semibold text-sm mt-1" style={{ color: '#E07B1A' }}>Founder &amp; CEO, KARFIN</p>
                <div className="flex flex-wrap gap-2 mt-2 justify-center sm:justify-start">
                  <span className="text-xs bg-orange-100 text-orange-700 px-2 py-0.5 rounded-full border border-orange-200">15+ Years Banking</span>
                  <span className="text-xs bg-gray-100 text-gray-600 px-2 py-0.5 rounded-full border border-gray-200">Fintech Expert</span>
                  <span className="text-xs bg-gray-100 text-gray-600 px-2 py-0.5 rounded-full border border-gray-200">HDFC • ICICI • BOB</span>
                </div>
                <p className="text-gray-500 text-sm mt-3 leading-relaxed">
                  With over <strong className="text-gray-900">15 years of banking expertise</strong>, Sabasis Nayak brings deep domain knowledge in financial services, credit, and lending to KARFIN. His vision is to democratise access to financial products for every Indian.
                </p>
                <a
                  href="https://www.linkedin.com/in/sabasis-nayak-a7821458"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 mt-4 text-sm font-semibold text-primary hover:text-orange-600 transition-colors"
                >
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                  </svg>
                  View LinkedIn Profile
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
